import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { VendorContext } from "../../../../context/vendor/VendorContext";
import { ContactContext } from "../../../../context/contact/ContactContext";
import SaveIcon from "@mui/icons-material/Save";
import { AlertSpan, CssNativeSelect, Root } from "../style";
import { ErrorOutline } from "@mui/icons-material";
import { Button, Container, Column, Tittle } from "../style";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import { Alert, Dialog, FormControl, InputLabel } from "@mui/material";
import {
  ButtonUpload,
  CssTextField,
  OptionSelect,
} from "../../Enrollment/style";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import Link from "@mui/material/Link";
import { OneColumn } from "../../Enrollment/naturalPerson/step3/style";
import { SearchButton } from "../../style";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import UpdateDialog from "../updateDialog";
import stylesCss, { Content, H3, H4 } from "./style";
import { useNavigate } from "react-router-dom";

const typeAccount = [
  {
    id: 0,
    name: "CUENTA CORRIENTE",
  },
  {
    id: 1,
    name: "CUENTA DE AHORROS",
  },
];
const typeIdentification = [
  {
    id: "R",
    name: "Ruc",
  },
  {
    id: "C",
    name: "Cédula",
  },
  {
    id: "P",
    name: "Pasaporte",
  },
];
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CreateBank = () => {
  const classesSx = stylesCss;
  let navigate = useNavigate();
  const { t } = useTranslation();
  const [nonNumber, setNonNumber] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const uploadCertificadoBancario = useRef(null);
  const [messageCountry, setMessageCountry] = useState(true);
  const uploaddocLegalRep = useRef(null);
  const uploadPaymAuth = useRef(null);
  const {
    vendorInformation,
    listBank,
    getListBank,
    getListCountry,
    getListProvince,
    getBase64,
    getVendorInformation,
    createVendBank,
    sendBankCertificateApproval,
  } = useContext(VendorContext);
  const { currentContact } = useContext(ContactContext);

  const [value, setValue] = useState(0);
  const [textWarning, setValueWarning] = useState("");
  const [success, setSuccess] = useState(false);
  const [dialogUpdate, setShowDialogUpdate] = useState(false);
  const [vendBankAccountLocal, setvendBankAccountLocal] = useState({
    id: "",
    namE_OWNER: "",
    identification: "",
    namE_BANK: "",
    namE_BANK_STR: "",
    nuM_ACCOUNT: "",
    typE_ACCOUNT: "",
    guiD_VEND: "",
    swifT_CODE: "",
    foreigN_SWIFT_CODE: "",
    typE_IDENTIFICATION: "R",
  });
  const [contactPersonBankLocal, setcontactPersonBankLocal] = useState({
    guiD_VEND: "",
    entitY_ID: "",
    email: "",
    phone: "",
    position: "",
    name: "",
    type: "",
  });
  const [documents, setdocuments] = useState([
    {
      translatioN_ID: "bankCertificate",
      basE64: "",
    },
  ]);
  const handleInformationBank = (event) => {
    event.preventDefault();

    setvendBankAccountLocal((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));

    if (event.target.name === "namE_BANK") {
      var index = event.nativeEvent.target.selectedIndex;
      setvendBankAccountLocal((prevState) => ({
        ...prevState,
        ["namE_BANK_STR"]: event.nativeEvent.target[index].text,
      }));
    }
    if (
      event.target.name === "identification" &&
      event.target.value !== vendorInformation.ruc
    ) {
      setdocuments([
        documents.filter((a) => a.translatioN_ID === "bankCertificate")[0],
        { translatioN_ID: "paymAuth", basE64: "" }, // and one new item at the end
        { translatioN_ID: "docLegalRep", basE64: "" }, // and one new item at the end
      ]);
    } else if (
      event.target.name === "identification" &&
      event.target.value === vendorInformation.ruc
    ) {
      setdocuments(
        documents.filter((a) => a.translatioN_ID === "bankCertificate")
      );
    }
  };
  const handleContactPersonInformationBank = (event) => {
    event.preventDefault();
    setcontactPersonBankLocal((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
    setNonNumber(false);
    // contactPersonBankLocal[event.target.name] = event.target.value;
    // setcontactPersonBankLocal(contactPersonBankLocal);
  };
  const handleChangeStep = (event, newValue) => {
    if (value === 4) {
      setOpenDialog(true);
      setValueWarning("requestPendingApproval");
    } else {
      validateInfo(newValue);
    }
  };
  const handleBackStepBtn = () => {
    setValue((val) => val - 1);
    window.scrollTo(0, 0);
  };
  const handleFinishStepBtn = () => {
    setValue((val) => val + 1);
    window.scrollTo(0, 0);
  };
  const handleChangeNextStepBtn = async (e) => {
    e.preventDefault();
    validateInfo(value + 1);
  };
  const validateInfo = (newValue) => {
    if (
      (newValue >= 2) &
      (vendBankAccountLocal.namE_BANK === "" ||
        vendBankAccountLocal.namE_OWNER === "" ||
        vendBankAccountLocal.nuM_ACCOUNT === "" ||
        vendBankAccountLocal.identification === "" ||
        vendBankAccountLocal.typE_ACCOUNT === "")
    ) {
      setOpenDialog(true);
      setValueWarning("incompleteInfo");
    } else if (
      (newValue >= 3) &
      (contactPersonBankLocal.name === "" ||
        contactPersonBankLocal.position === "" ||
        contactPersonBankLocal.email === "" ||
        contactPersonBankLocal.phone === "")
    ) {
      setOpenDialog(true);
      setValueWarning("incompleteInfo");
    } else {
      //elimina los otros documentos
      // setdocuments(
      //   documents.filter((a) => a.translatioN_ID === "bankCertificate")
      // );
      // if (vendBankAccountLocal.identification !== vendorInformation.ruc) {
      //   // setdocuments([
      //   //   ...documents, // that contains all the old items
      //   //   { translatioN_ID: "paymAuth", basE64: "" }, // and one new item at the end
      //   //   { translatioN_ID: "docLegalRep", basE64: "" }, // and one new item at the end
      //   // ]);
      //   if (documents.length === 1) {
      //     setdocuments([
      //       documents.filter((a) => a.translatioN_ID === "bankCertificate")[0],
      //       { translatioN_ID: "paymAuth", basE64: "" }, // and one new item at the end
      //       { translatioN_ID: "docLegalRep", basE64: "" }, // and one new item at the end
      //     ]);
      //   }
      // }
      setValue(newValue);
      window.scrollTo(0, 0);
    }
  };
  const handleFileUpload = (event) => {
    const fileUploaded = event.target.files[0];
    getBase64(fileUploaded)
      .then((data) => {
        const myNextList = [...documents];
        const doc = myNextList.find(
          (a) => a.translatioN_ID === event.target.name
        );
        doc.basE64 = data;
        setdocuments(myNextList);
      })
      .catch((error) => {
        alert("Error: " + error.currentTarget.error);
      });
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseCountry = () => {
    setMessageCountry(false);
  };
  const submitFormBankInfo = async (e) => {
    e.preventDefault();
    let alert = false;
    for (let index = 0; index < documents.length; index++) {
      alert = documents[index].basE64 === "" ? true : false;
      if (alert) break;
    }
    if (alert) {
      setValueWarning("alertMissingAttach");
      setOpenDialog(true);
    } else if (vendorInformation.guiD_PRIMARY_CONTACT !== "") {
      setValueWarning("");
      setOpenDialog(false);
      setShowDialogUpdate(true);

      const guidVend = vendorInformation.guiD_PRIMARY_CONTACT;
      vendBankAccountLocal["guiD_VEND"] = guidVend;
      contactPersonBankLocal["guiD_VEND"] = guidVend;

      contactPersonBankLocal["type"] = "2";
      const banK_DOCUMENTS = {
        venD_BANK_ID: vendBankAccountLocal["namE_BANK"],
        document: documents,
      };
      vendBankAccountLocal["contactPerson"] = contactPersonBankLocal;
      vendBankAccountLocal["bankDocuments"] = banK_DOCUMENTS;
      vendBankAccountLocal["createdFrom"] = "vss";
      const resp = await createVendBank(vendBankAccountLocal);
      const respSendBankCertificateApproval = await sendBankCertificateApproval(
        resp
      );
      if (respSendBankCertificateApproval !== null) {
        setSuccess(true);
        setTimeout(() => {
          setShowDialogUpdate(false);
        }, 1500);
      } else {
        setSuccess(true);
        setTimeout(() => {
          setShowDialogUpdate(false);
        }, 1500);
        setValueWarning("errorMessage");
        setOpenDialog(true);
      }
      handleFinishStepBtn();
    } else {
      setSuccess(true);
      setTimeout(() => {
        setShowDialogUpdate(false);
      }, 1500);
      setValueWarning("errorMessage");
      setOpenDialog(true);
    }
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getVendorInformation(currentContact)]);
    };
    fetchData2();
  }, []);

  useEffect(() => {
    const fetchData2 = async () => {
      if (vendorInformation.country === "ECU") {
        console.log(vendorInformation.country);
        await Promise.all([
          getListProvince(vendorInformation.country),
          getListBank(vendorInformation.company),
        ]);
      }
    };
    fetchData2();
  }, [vendorInformation.country]);

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([
        getListCountry(vendorInformation.company),
        getListBank(vendorInformation.company),
      ]);
    };
    fetchData2();
  }, [vendorInformation.company]);

  useEffect(() => {
    const fetchData2 = async () => {
      if (vendorInformation.ruc !== "") {
        setvendBankAccountLocal((prevState) => ({
          ...prevState,
          ["identification"]: vendorInformation.ruc,
        }));
      }
    };
    fetchData2();
  }, [vendorInformation]);

  return (
    <>
      <UpdateDialog
        success={success}
        showDialogUpdate={dialogUpdate}
        setShowDialogUpdate={setShowDialogUpdate}
        textTittle={t("savingInformation")}
      />
      <Dialog onClose={handleCloseDialog} open={openDialog}>
        <br />
        <Container>
          <H3 style={{ textAlign: "center" }}>{t(textWarning)}</H3>
        </Container>
        <Container>
          <OneColumn style={{ textAlign: "center" }}>
            <SearchButton onClick={handleCloseDialog}>
              {t("close")}
            </SearchButton>
          </OneColumn>
        </Container>
      </Dialog>
      <Root>
        {vendorInformation.country === null ||
        vendorInformation.country === "" ? (
          <Dialog onClose={handleCloseCountry} open={messageCountry}>
            <br />
            <Container style={{ textAlign: "center" }}>
              <H3>{t("notificationCountry")}</H3>
            </Container>
            <Container style={{ textAlign: "center" }}>
              <OneColumn>
                <SearchButton onClick={handleCloseCountry}>
                  {t("close")}
                </SearchButton>
              </OneColumn>
            </Container>
          </Dialog>
        ) : (
          <>
            <Tabs
              sx={{ ...classesSx.selectedTab }}
              value={value}
              onChange={handleChangeStep}
            >
              <Tab label="1" {...a11yProps(0)} />
              <Tab label="2" {...a11yProps(1)} />
              <Tab label="3" {...a11yProps(2)} />
              <Tab label="4" {...a11yProps(3)} />
              <Tab label="5" {...a11yProps(4)} />
            </Tabs>
            <TabPanel value={value} index={0}>
              <Content>
                <OneColumn>
                  <H3>
                    <InfoIcon fontSize="large" color="info" />
                    {" " + t("alertBankAccReg")}
                  </H3>
                  <H4>{t("alertLifeMainAcc")}</H4>
                  <H3>
                    <InfoIcon fontSize="large" color="info" />
                    {" " + t("mandatoryDoc")}
                  </H3>
                  <H4>{t("bankCertificate")}</H4>
                  <H3>
                    <InfoIcon fontSize="large" color="info" />
                    {" " + t("alertNonMatchAcc")}
                  </H3>
                  <H4>{t("docLegalRep")}</H4>
                  <H4>
                    {t("paymAuth")}
                    {". "}
                    <Link
                      rel="noopener noreferrer"
                      href="https://shorturl.at/iqJQY"
                      target="_blank"
                    >
                      {"(" + t("downloadFmt") + ")"}
                    </Link>
                  </H4>
                </OneColumn>
              </Content>
              <Container>
                <OneColumn>
                  <Button onClick={handleChangeNextStepBtn}>{t("next")}</Button>
                </OneColumn>
              </Container>
            </TabPanel>
            <form onSubmit={handleChangeNextStepBtn}>
              <TabPanel value={value} index={1}>
                <Tittle>{t("bankInformation")}</Tittle>
                <Container>
                  {vendorInformation.country === "ECU" && (
                    <>
                      <Column>
                        <FormControl required fullWidth>
                          <InputLabel variant="standard">
                            {t("bank")}
                          </InputLabel>
                          <CssNativeSelect
                            value={vendBankAccountLocal.namE_BANK}
                            id="namE_BANK"
                            name="namE_BANK"
                            onChange={(e) => handleInformationBank(e)}
                          >
                            <OptionSelect></OptionSelect>
                            {listBank.map((item) => (
                              <OptionSelect
                                key={item.bankGroupId}
                                value={item.bankGroupId}
                              >
                                {item.name}
                              </OptionSelect>
                            ))}
                          </CssNativeSelect>
                        </FormControl>
                      </Column>
                    </>
                  )}
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={vendBankAccountLocal.namE_OWNER}
                      required={true}
                      fullWidth
                      label={t("accountOwnerName")}
                      id="namE_OWNER"
                      name="namE_OWNER"
                      onChange={(e) => handleInformationBank(e)}
                    />
                  </Column>
                  <Column>
                    <FormControl required fullWidth>
                      <InputLabel variant="standard">
                        {t("typeIdentification")}
                      </InputLabel>
                      <CssNativeSelect
                        value={vendBankAccountLocal.typE_IDENTIFICATION}
                        id="typE_IDENTIFICATION"
                        name="typE_IDENTIFICATION"
                        onChange={(e) => handleInformationBank(e)}
                      >
                        {typeIdentification.map((item) => (
                          <OptionSelect key={item.id} value={item.id}>
                            {item.name}
                          </OptionSelect>
                        ))}
                      </CssNativeSelect>
                    </FormControl>
                  </Column>

                  <Column>
                    <CssTextField
                      type={"text"}
                      required={true}
                      value={vendBankAccountLocal.identification}
                      fullWidth
                      label={t("identityCard")}
                      id="identification"
                      name="identification"
                      onChange={(e) => handleInformationBank(e)}
                    />
                  </Column>
                  {vendorInformation.ruc !==
                    vendBankAccountLocal.identification && (
                    <OneColumn>
                      <Alert severity="warning">
                        <strong>{t("alertNonMatchAcc") + ":"}</strong>
                        <List
                          sx={{
                            width: "100%",
                            maxWidth: 360,
                            paddingBottom: 2,
                          }}
                        >
                          <ListItem sx={{ paddingBottom: 0 }}>
                            <ListItemText
                              primary={"- " + t("docLegalRep")}
                              secondary=""
                            />
                          </ListItem>
                          <ListItem sx={{ paddingBottom: 0 }}>
                            <ListItemText
                              primary={"- " + t("paymAuth")}
                              secondary={
                                <Link
                                  rel="noopener noreferrer"
                                  href="https://shorturl.at/iqJQY"
                                  target="_blank"
                                >
                                  {t("downloadFmt")}
                                </Link>
                              }
                            />
                          </ListItem>
                        </List>
                      </Alert>
                    </OneColumn>
                  )}
                  <Column>
                    <CssTextField
                      type={"text"}
                      required={true}
                      value={vendBankAccountLocal.nuM_ACCOUNT}
                      fullWidth
                      label={t("accountNum")}
                      id="nuM_ACCOUNT"
                      name="nuM_ACCOUNT"
                      onChange={(e) => handleInformationBank(e)}
                    />
                  </Column>
                  <Column>
                    <FormControl required fullWidth>
                      <InputLabel variant="standard">
                        {t("accountType")}
                      </InputLabel>
                      <CssNativeSelect
                        value={vendBankAccountLocal.typE_ACCOUNT}
                        id="typE_ACCOUNT"
                        name="typE_ACCOUNT"
                        onChange={(e) => handleInformationBank(e)}
                      >
                        <OptionSelect></OptionSelect>
                        {typeAccount.map((item) => (
                          <OptionSelect key={item.id} value={item.id}>
                            {item.name}
                          </OptionSelect>
                        ))}
                      </CssNativeSelect>
                    </FormControl>
                  </Column>
                </Container>
                <Container>
                  <Column>
                    <Button onClick={handleBackStepBtn}>{t("back")}</Button>
                  </Column>
                  <Column>
                    <Button type="submit">{t("next")}</Button>
                  </Column>
                </Container>
              </TabPanel>
            </form>
            <form onSubmit={handleChangeNextStepBtn}>
              <TabPanel value={value} index={2}>
                <Tittle>{t("contactInfBankNotif")}</Tittle>
                <Container>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={contactPersonBankLocal.name}
                      required={true}
                      fullWidth
                      label={t("fullName")}
                      id="name"
                      name="name"
                      onChange={(e) => handleContactPersonInformationBank(e)}
                    />
                  </Column>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={contactPersonBankLocal.position}
                      required={true}
                      fullWidth
                      label={t("position")}
                      id="position"
                      name="position"
                      onChange={(e) => handleContactPersonInformationBank(e)}
                    />
                  </Column>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={contactPersonBankLocal.phone}
                      required={true}
                      fullWidth
                      label={t("phone")}
                      id="phone"
                      name="phone"
                      onChange={(e) => handleContactPersonInformationBank(e)}
                    />
                    {nonNumber && contactPersonBankLocal.phone === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incorrectValue")}
                      </AlertSpan>
                    )}
                  </Column>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={contactPersonBankLocal.email}
                      required={true}
                      fullWidth
                      label={t("email")}
                      id="email"
                      name="email"
                      onChange={(e) => handleContactPersonInformationBank(e)}
                    />
                  </Column>
                </Container>
                <Container>
                  <Column>
                    <Button onClick={handleBackStepBtn}>{t("back")}</Button>
                  </Column>
                  <Column>
                    <Button type="submit">{t("next")}</Button>
                  </Column>
                </Container>
              </TabPanel>
            </form>
            <form onSubmit={submitFormBankInfo}>
              <TabPanel value={value} index={3}>
                <Tittle>{t("documentation")}</Tittle>
                <Container>
                  {documents.length > 0 && (
                    <>
                      <OneColumn>
                        <ButtonUpload
                          onClick={(e) => {
                            e.preventDefault();
                            uploadCertificadoBancario.current.click();
                          }}
                        >
                          <UploadFileIcon />
                          {t("bankCertificate")}
                          {documents.filter(
                            (doc) => doc.translatioN_ID === "bankCertificate"
                          )[0]["basE64"] !== "" && (
                            <>
                              <br />
                              <DoneAllIcon fontSize="large" />
                            </>
                          )}
                        </ButtonUpload>
                        <input
                          type="file"
                          accept="application/pdf"
                          name={"bankCertificate"}
                          ref={uploadCertificadoBancario}
                          onChange={(e) => handleFileUpload(e)}
                          style={{ display: "none" }}
                        />
                      </OneColumn>
                      {vendorInformation.ruc !==
                        vendBankAccountLocal.identification && (
                        <>
                          <OneColumn>
                            <ButtonUpload
                              onClick={(e) => {
                                e.preventDefault();
                                uploaddocLegalRep.current.click();
                              }}
                            >
                              <UploadFileIcon />
                              {t("docLegalRep")}
                              {documents.filter(
                                (doc) => doc.translatioN_ID === "docLegalRep"
                              ).length > 0 &&
                                documents.filter(
                                  (doc) => doc.translatioN_ID === "docLegalRep"
                                )[0]["basE64"] !== "" && (
                                  <>
                                    <br />
                                    <DoneAllIcon fontSize="large" />
                                  </>
                                )}
                            </ButtonUpload>
                            <input
                              type="file"
                              accept="application/pdf"
                              name={"docLegalRep"}
                              ref={uploaddocLegalRep}
                              onChange={(e) => handleFileUpload(e)}
                              style={{ display: "none" }}
                            />
                          </OneColumn>
                          <OneColumn>
                            <ButtonUpload
                              onClick={(e) => {
                                e.preventDefault();
                                uploadPaymAuth.current.click();
                              }}
                            >
                              <UploadFileIcon />
                              {t("paymAuth")}
                              {documents.filter(
                                (doc) => doc.translatioN_ID === "paymAuth"
                              ).length > 0 &&
                                documents.filter(
                                  (doc) => doc.translatioN_ID === "paymAuth"
                                )[0]["basE64"] !== "" && (
                                  <>
                                    <br />
                                    <DoneAllIcon fontSize="large" />
                                  </>
                                )}
                            </ButtonUpload>
                            <input
                              type="file"
                              accept="application/pdf"
                              name={"paymAuth"}
                              ref={uploadPaymAuth}
                              onChange={(e) => handleFileUpload(e)}
                              style={{ display: "none" }}
                            />
                          </OneColumn>
                        </>
                      )}
                    </>
                  )}
                </Container>
                <Container>
                  <Column>
                    <Button onClick={handleBackStepBtn}>{t("back")}</Button>
                  </Column>
                  <Column>
                    <Button type="submit">
                      {t("save")} <SaveIcon />
                    </Button>
                  </Column>
                </Container>
              </TabPanel>
            </form>
            <TabPanel value={value} index={4}>
              <Container>
                <h3>
                  {t("requestPendingApproval") + " " + t("notificationMessage")}
                </h3>
              </Container>
              <Container>
                <OneColumn>
                  <Button onClick={() => navigate("/")}>{t("finish")}</Button>
                </OneColumn>
              </Container>
            </TabPanel>
          </>
        )}
      </Root>
    </>
  );
};

export default CreateBank;
